import React, { useRef } from "react";
import LanguageHelper from "../../../../../helpers/LanguageHelper";
import Table from "../../../../../components/Table/Table";
import FetchData from "./FetchData";
import TableBackdrop from "../../../../../components/Table/TableBackdrop";
import CustomSnackbar from "../../../../../components/Snackbar/Snackbar";
import LogsDisplay from "./LogsDisplay";
import { statusTranslations } from "../../../../../assets/constants";
import ApplicationUpdateModal from "./ApplicationUpdateModal";
import LatestArtifactInfo from "./LatestArtifactInfo";
import GetOptions from "./GetOptions";

export default function ApplicationUpdatesTable() {
  const tableRef = useRef();
  const language = LanguageHelper.getLanguage();

  const [numOfEntries, setNumOfEntries] = React.useState(0);
  const [backdropLoading, setBackdropLoading] = React.useState(false);
  const [snackbar, setSnackbar] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [severity, setSeverity] = React.useState("info");
  const [modal, setModal] = React.useState(false);
  const [options, setOptions] = React.useState({});
  const [columns, setColumns] = React.useState([]);

  const init = React.useCallback(async () => {
    setBackdropLoading(true);
    const options = await GetOptions();
    setOptions(options);
    const columns = [
      {
        field: "id",
        title: language.tableColumns.id,
      },
      {
        field: "startDate",
        title: language.applicationUpdates.startDate,
      },
      {
        field: "type",
        title: language.applicationUpdates.type,
      },
      {
        field: "username",
        title: language.applicationUpdates.username,
        sorting: false,
      },
      {
        field: "status",
        title: language.applicationUpdates.status,
        render: (rowData) => {
          return statusTranslations[rowData.status] || rowData.status;
        },
      },
      {
        field: "description",
        title: language.applicationUpdates.description,
        width: "40%",
        sorting: false,
        render: (rowData) => (
            <div
                style={{
                  maxHeight: "100px",
                  overflowY: "auto",
                  whiteSpace: "pre-wrap",
                }}
            >
              {rowData.description}
            </div>
        ),
      },
      {
        field: "isBackupNeeded",
        title: "Veritabanı Yedeklensin Mi?",
        render: (rowData) => {
          return rowData.isBackupNeeded ? language.etc.yes : language.etc.no;
        },
        sorting: false,
      },
      {
        field: "logs",
        title: language.applicationUpdates.logs,
        sorting: false,
        render: (rowData) => (
          <LogsDisplay logs={rowData.logs} id={rowData.id} />
        ),
      },
    ];
    setColumns(columns);
    setBackdropLoading(false);
  }, [language]);
  React.useEffect(() => {
    init();
  }, [init]);

  const handleOpenModal = () => {
    setModal(true);
  };

  return (
    <>
      <TableBackdrop backdropLoading={backdropLoading} />
      <CustomSnackbar
        snackbar={snackbar}
        setSnackbar={setSnackbar}
        snackbarMessage={snackbarMessage}
        severity={severity}
      />
      <ApplicationUpdateModal
        modal={modal}
        setModal={setModal}
        setSnackbar={setSnackbar}
        setSnackbarMessage={setSnackbarMessage}
        setSeverity={setSeverity}
        tableRef={tableRef}
        options={options}
      />
      <LatestArtifactInfo options={options} />
      <Table
        noRowActions
        tableRef={tableRef}
        authName="medasProdAppUpdate"
        tableName={language.sidebar.application_updates}
        columns={columns}
        fetchData={FetchData}
        numOfEntries={numOfEntries}
        setNumOfEntries={setNumOfEntries}
        setSnackbar={setSnackbar}
        setSnackbarMessage={setSnackbarMessage}
        setSeverity={setSeverity}
        handleOpenModal={handleOpenModal}
        rowStyle={(rowData) => ({
          backgroundColor:
            rowData.status === "COMPLETED"
              ? "#33ff99"
              : rowData.status === "IN_PROGRESS"
              ? "#33ccff"
              : rowData.status === "FAILED"
              ? "#cc6666"
              : "white",
        })}
      />
    </>
  );
}
